import { JobState } from '@treadinc/horizon-api-spec';

export enum MarkerType {
  truck = 'truck',
  site = 'site',
  moving_site = 'moving_site',
  ping = 'ping',
  pickup_site = 'pickup_site',
  dropoff_site = 'dropoff_site',
  staging_site = 'staging_site',
  both_site = 'both_site',
  /** Orange pickup icon for naive/accuracy_strict geofences (Job Geo Debug). */
  pickup_site_geo_debug = 'pickup_site_geo_debug',
  /** Orange dropoff icon for naive/accuracy_strict geofences (Job Geo Debug). */
  dropoff_site_geo_debug = 'dropoff_site_geo_debug',
  hidden_marker = 'hidden_marker',
}

export enum GeofenceType {
  polygon = 'polygon',
  circle = 'circle',
}

export const HIGHLIGHT_MARKER_RADIUS = 12;
export const ROUTE_MARKER_RADIUS = 8;

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'google-map-script',
  googleMapsApiKey: import.meta.env.TREAD__GOOGLE_MAPS_API_KEY,
  version: '3.58',
};

export const ACTIVE_JOB_STATES = [
  JobState.TO_PICKUP,
  JobState.ARRIVED_PICKUP,
  JobState.LOADED,
  JobState.TO_DROPOFF,
  JobState.ARRIVED_DROPOFF,
  JobState.UNLOADED,
];

export const DONE_JOB_STATES = [
  JobState.COMPLETED,
  JobState.CANCELED,
  JobState.REJECTED,
  JobState.ENDED,
];

export const MAP_RECENTER_SPEED_MS = 100;

// Under normal conditions the map fires 'idle' within a frame or two of a fit;
// if it never does (e.g. the container is hidden or zero-size mid-fit), this
// bounds how long zooming past the fit cap stays blocked. Well above the time
// a fit needs to compute its clamped target zoom.
export const MAX_ZOOM_CAP_LIFT_FALLBACK_MS = 3000;
